module.exports = __webpack_public_path__ + "media/images/pic/anime/box-blog-type3-04f00e8841c2525111118195d6c91d57.svg";